var stdin_default = function() {
  function t() {
    this.name = "scale";
  }
  return t.prototype.css = function(t2, e) {
    if (t2 && t2.length) {
      if (e) return t2.css("transform", "scale(" + e + ")");
    }
    return null;
  }, // 创建 DOM
  t.prototype.createTarget = function(t2, i, e) {
    return this.target = hiprintJQuery(
      '<div class="hiprint-option-item">\n        <div class="hiprint-option-item-label">\n        \u7F29\u653E\n        </div>\n        <div class="hiprint-option-item-field">\n        <input type="number" value="1" step="0.1" min="0.1" max="3" class="auto-submit"/>\n        </div>\n    </div>'
    ), this.target;
  }, // 获取值
  t.prototype.getValue = function() {
    var t2 = this.target.find("input").val();
    if (t2) return parseFloat(t2.toString());
  }, // 设置值
  t.prototype.setValue = function(t2) {
    this.target.find("input").val(t2);
  }, // 销毁 DOM
  t.prototype.destroy = function() {
    this.target.remove();
  }, t;
}();
export {
  stdin_default as default
};
